import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

export type LoaderComponentProps = {};

const LoaderComponent: React.FC<LoaderComponentProps> = () => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <CircularProgress color="inherit" />

    </Backdrop>
  );
};

export default LoaderComponent;
